reportService.$inject = [
  'alertService',
  'jsSdk.dataExport',
  '$interval',
  '$timeout'
];

export default function reportService(alertService, dataExportService, $interval, $timeout) {
  class ReportService {
    create(options) {
      if (!options) throw new Error('options');

      alertService.success('Download should start in a few seconds. An email will also be sent to you.');

      this._reset();

      return dataExportService.create(options)
        .then(report => {
          this._report = report;

          this._startPolling();
        })
        .catch(() => {
          alertService.error('An error occurred');
        });
    }

    _reset() {
      this._report = null;

      this._stopPolling();
    }

    _startPolling() {
      this._getDataExportInterval = $interval(this._getExportById.bind(this), 3000);
    }

    _stopPolling() {
      if (this._getDataExportInterval) {
        $interval.cancel(this._getDataExportInterval);
      }
    }

    _getExportById() {
      if (!this._report) throw new Error('this._report');

      return dataExportService.readById(this._report.id)
        .then(result => {
          this._report = result;

          if (this._report.stateType === 'COMPLETE') {
            this._stopPolling();

            return this._getExportDownloadUrlById();
          } else if (this._report.stateType === 'FAILED') {
            this._stopPolling();
          }

          return null;
        })
        .catch(error => {
          this._stopPolling();

          console.log('error polling for report', error);
        });
    }

    _getExportDownloadUrlById() {
      if (!this._report) throw new Error('this._report');

      return dataExportService.getDownloadUrlById(this._report.id)
        .then(result => {
          $timeout(() => {
            window.open(result.url);
          }, 500);

          $timeout(() => {
            this._reset();
          }, 1000);
        })
        .catch(error => {
          this.$store.dispatch('addTopBarNotification', {
            text: error.message
          });
        });
    }
  }

  return new ReportService();
}



// WEBPACK FOOTER //
// ./src/services/reportService.js